<template>
    <Disclosure
        as="div"
        v-slot="{ open }"
        class="relative group"
    >
        <div
            class="p-[10px] bg-white rounded-[8px] shadow-small-card"
            @mouseenter="emit('warning:hover', warning.warningId)"
            @mouseleave="emit('warning:leave')"
        >
            <DisclosureButton class="cursor-pointer select-none" as="div">
                <div class="flex items-center gap-[10px]">
                    <div
                        :class="['w-[6px] h-[6px] rounded-full', CATEGORY_STYLE[warning.warningType]]"
                    ></div>
                    <span class="uppercase text-[12px] text-[#8897AA]">{{
                        warning.warning
                    }}</span>
                </div>

                <div v-if="!open" class="pl-4">
                    <p class="text-[14px] text-won-black">
                        {{ warning?.shortMessage }}
                    </p>
                </div>
            </DisclosureButton>

            <DisclosurePanel class="pl-4">
                <p class="text-[14px] text-won-black">
                    {{ warningText }}
                </p>

                <div class="mt-2" v-if="Object.values(WARNING_CATEGORIES).includes(warning.warningCategory)">
                    <button
                        class="text-white bg-won-green text-[12px] rounded py-[3px] px-[6px] flex items-center gap-1 select-none"
                        @click="refreshHandler"
                    >
                        <RefreshIcon
                            color="#fff"
                            classList="h-4 w-4"
                        />
                        Refresh
                    </button>
                </div>
            </DisclosurePanel>
        </div>

        <span
            class="absolute top-[10px] right-[10px] group-hover:block hidden cursor-pointer"
            @click="deleteWarningHandler"
        >
            <DeleteIconRed/>
        </span>
    </Disclosure>
</template>

<script setup>
import { ref, toRefs, watch } from 'vue'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';
import { CATEGORY_STYLE, WARNING_CATEGORIES } from '../../utils/scorer-lib';
import RefreshIcon from "../../icons/actions/refresh.vue"
import { useRoute } from 'vue-router'

import { MESSAGES_TEMPLATES } from "../../utils/scorer-lib"

import DeleteIconRed from '../../icons/delete-icon-red.vue';

import { useIgnoreWarnings } from "../../store/scorer-warnings.store"

const route = useRoute()
const emit = defineEmits(['warning:hover', 'warning:leave', 'warning:delete'])
const props = defineProps({
    warning: {
        type: Object,
        default: {}
    }
})

const { warning } = toRefs(props)
const warningText = ref(warning.value.detailedMessage || '')
const warningsStore = useIgnoreWarnings()

watch(warning, (newWarning) => {
    warningText.value = newWarning.detailedMessage || '';
})

const refreshHandler = () => {
    const { warningCategory, refresh } = warning.value

    if(warningCategory === WARNING_CATEGORIES.strongVerbs) {
        const { verb } = warning.value
        const newStrongVerbs = refresh().verbs
        
        warningText.value = MESSAGES_TEMPLATES.strongActionVerbs.replace('<<verb>>', verb).replace('<<proposedVerbs>>' , newStrongVerbs.join(', '))
    }else if(warningCategory === WARNING_CATEGORIES.keyWords){
        const newKeywords = refresh()

        warningText.value = MESSAGES_TEMPLATES.keyWords.replace('<<keywords>>', newKeywords.join(', '))
    }
}

const deleteWarningHandler = () => {
    warningsStore.ignoreWarning(route.params.id, warning.value.warningId)
}
</script>
